import { format } from 'date-fns';

export const generateFileName = (text) => {
  if (typeof text !== 'string') throw new Error('Only string accepted');

  const textSepareteByUnderline = text.toLowerCase().split(' ').join('_');

  const dateSepareteByUnderline = format(new Date(), 'dd_MM_yyyy');

  return `${textSepareteByUnderline}_${dateSepareteByUnderline}`;
};
